module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/th_okinawa-d58a031e2e58d6b024742707fb05269b.jpg";